<div class="modal-draft-orders">
    <div class="modal-header">
        <h2>
            {{ 'protocol_orders.drafts.title' | translate }}
        </h2>
        <button (click)="onCancel()" aria-label="Cerrar" class="btn-close">
            <img src="assets/icons/close-modal.svg" alt="Cerrar" />
        </button>
    </div>

    <div class="modal-subtitle">
        {{ 'protocol_orders.drafts.subtitle' | translate: { count: drafts.length } }}
    </div>

    <div class="drafts-list">
        <div *ngFor="let draft of drafts" class="draft-card">
            <div class="draft-header">
                <div class="draft-vehicle">
                    <img src="assets/icons/car.svg" alt="Vehículo" class="vehicle-icon" />
                    <span class="license-plate">{{ draft.vehicleLicensePlate }}</span>
                </div>
                <span class="draft-id">{{ draft.externalId }}</span>
            </div>

            <div class="draft-body">
                <div class="draft-info-row">
                    <img src="assets/icons/user.svg" alt="Cliente" class="info-icon" />
                    <span class="info-text" *ngIf="draft.clientFullName">{{ draft.clientFullName }}</span>
                    <span class="info-text warning" *ngIf="!draft.clientFullName">
                        ⚠️ {{ 'protocol_orders.drafts.noClient' | translate }}
                    </span>
                </div>

                <div class="draft-info-row" *ngIf="draft.clientPhone">
                    <img src="assets/icons/phone.svg" alt="Teléfono" class="info-icon" />
                    <span class="info-text">{{ draft.clientPhone }}</span>
                </div>

                <div class="draft-info-row">
                    <img src="assets/icons/calendar.svg" alt="Fecha" class="info-icon" />
                    <span class="info-text">
                        {{ 'protocol_orders.drafts.startedOn' | translate }}: {{ formatDate(draft.startDate) }}
                    </span>
                </div>

                <!-- <div class="draft-info-row">
                    <img src="assets/icons/clock.svg" alt="Última modificación" class="info-icon" />
                    <span class="info-text">
                        {{ 'protocol_orders.drafts.lastModified' | translate }}: {{ formatDate(draft.lastModification) }}
                        <span class="days-ago">({{ getDaysAgo(draft.lastModification) }} {{ 'protocol_orders.drafts.daysAgo' | translate }})</span>
                    </span>
                </div> -->
            </div>

            <div class="draft-actions">
                <button mat-flat-button color="primary" class="btn-continue"
                    (click)="onContinueDraft(draft.externalId)">
                    {{ 'protocol_orders.drafts.continue' | translate }}
                </button>
            </div>
        </div>
    </div>

    <div class="modal-footer">
        <button mat-stroked-button color="primary" class="btn-create-new" (click)="onCreateNew()">
            <!-- <img src="assets/icons/plus.svg" alt="+" /> -->
            {{ 'protocol_orders.drafts.createNew' | translate }}
        </button>
    </div>
</div>
